import { computed, reactive, ref, watch } from "@vue/composition-api";
import { useRouter, useStore, useUpdates } from '../../core/hooks'
import { requestsUseCase } from "../../core/usecases";
import queries from './queries'



const useCpRequestAlert = () => {
    const { route } = useRouter()
    const { state, store } = useStore()
    const { updates } = useUpdates()
    const updateDateState = reactive({
        loading: false,
        updateDate: null
    })
    
    watch([route,updates], async ([route,updates]) => {
        const userId = state.value.user.uid
        const partnerCampaignId = route.params.campaignID
        const myCampaign = computed(() => state.value.publishedCampaignIds.find(camp => partnerCampaignId === camp.id))
        if(myCampaign.value) {
            return updateDateState.updateDate
        }
        updateDateState.loading = true
        if(!updates.length) {
            return
        }
        try {
            updateDateState.updateDate = await requestsUseCase.getRequestWithPartner(
                queries.findRequestWithPartner(userId, partnerCampaignId),
                userId,
            )
        } catch(e) {
            console.error(e);
        } finally {
            updateDateState.loading = false
        }

    }, {immediate: true})

    return {
        updateDateState
    }
        
}
export default useCpRequestAlert
